<template>
  <div>
    <div
      :class="[
        {
          must: fieldObj.required == 1,
          err: fieldObj.dirty && fieldObj.invalid
        },
        fieldStyle
      ]"
    >
      <div style="display: flex; align-items: self-end">
        <VueCountryIntl type="phone" :searchAble="true"  v-model="phone" :onlyValue="true"
                        :showAreaCode="true"  :useChinese="true"  schema="input" :iosMobileReadonly="false"
                        v-if="fieldObj.fieldName=='mobile' && field.isCallingCodeOpen == 1"
                        :onlyCountry="onlyCountry"
                        :showSelectedText="false"
                        @onChange="changePhone"
        ></VueCountryIntl>
        <div class="m-input-content">
          <div v-if="fieldStyle == 'style1-wap'" class="u-label" :class="{calling:field.isCallingCodeOpen == 1}">
            {{ fieldObj.displayName }}
          </div>
          <div v-if="fieldStyle == 'style2-wap'" class="opacityText">
            {{ fieldObj.displayName }}
          </div>

          <a-input
            maxlength="500"
            v-if="!isPassword"
            @blur="blur($event)"
            class="status-input"
            :placeholder="
              fieldStyle == 'style1-wap'
                ? fieldObj.fieldLevel == 4
                  ? '请输入'
                  : '请输入' + fieldObj.displayName
                : ''
            "
            @change="textChange"
            v-model="inputValue"
          />

          <a-input-password
            v-if="isPassword"
            class="status-input"
            :placeholder="
              fieldStyle == 'style1-wap' ? '请输入' + fieldObj.displayName : ''
            "
            @change="textChange"
            v-model="inputValue"
          />
          <div
            v-if="fieldStyle == 'style2-wap'"
            class="u-label"
            :class="{
              moved: inputValue
            }"
          >
            {{ fieldObj.displayName }}
          </div>
        </div>
      </div>
      <div class="select-items" v-show="isShowBussiness" v-if="fieldObj.fieldName=='enterprise'">
        <div v-for="(b,i) in businessList" :key="i" @click="setBusiness(b)" class="item">
          <div class="name" v-html="b.showName"></div>
          <!--<div class="info">-->
            <!--<span>法人：{{b.legalPersonName}}</span>-->
            <!--<span class="split"></span>-->
            <!--<span class="status">经营状况：{{b.regStatus}}</span></div>-->
        </div>
      </div>
      <div class="u-reg-err-tips" v-show="fieldObj.dirty && fieldObj.invalid">
        {{ fieldObj.validationMessage }}
      </div>
      <div ref="errorDesc" class="u-reg-err-tips gray" v-show="fieldObj.fieldName=='enterprise' && fieldObj.submitBusiness==0">
      </div>
    </div>
    <div
      v-if="fieldObj.isSendSms == 1"
      :class="[
        {
          must: fieldObj.required == 1,
          err:
            fieldObj.isSendSms == 1 &&
            fieldObj.verificationCodeDirty &&
            fieldObj.verificationCodeError
        },
        fieldStyle
      ]"
    >
      <div class="m-input-content">
        <div v-if="fieldStyle == 'style1-wap'" class="u-label">
          验证码
        </div>
        <div v-if="fieldStyle == 'style2-wap'" class="opacityText">
          {{ fieldObj.displayName }}
        </div>
        <div class="m-input code-text">
          <a-input
            class="status-input"
            :placeholder="fieldStyle == 'style1-wap' ? '请输入验证码' : ''"
            @change="smsChange($event)"
            :max-length="6"
            v-model="fieldObj.verificationCode"
          />
          <div
            v-if="fieldStyle == 'style2-wap'"
            class="u-label"
            :class="{
              moved: fieldObj.verificationCode
            }"
          >
            验证码
          </div>
          <a-button
              class="sendCodeBtn sendCodeBtn-color"
            :type="fieldStyle == 'style1-wap' ? 'primary' : 'link'"
            :class="{ active: fieldObj.sendCodeJson.time != 0 }"
            :style="fieldObj.sendCodeJson.time != 0 ? 'color:rgba(0, 0, 0, 0.65) !important' : ''"
            @click="sendCode"
            :disabled="fieldObj.sendCodeJson.disabled"
            v-text="
              fieldObj.sendCodeJson.time == 0
                ? '获取验证码'
                : fieldObj.sendCodeJson.time + '秒'
            "
          />
        </div>
      </div>

      <div
        class="u-reg-err-tips"
        v-show="
          fieldObj.isSendSms == 1 &&
            fieldObj.verificationCodeDirty &&
            fieldObj.verificationCodeError
        "
      >
        请填写验证码
      </div>
    </div>
  </div>
</template>
<script>
import inputMixin from "../../field/new-fields/input";
export default {
  name: "sk-input-wap",
  props: {
    fieldStyle: {
      type: String,
      default: "style1-wap"
    }
  },
  mixins: [inputMixin]
};
</script>
<style lang=""></style>